var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayer2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 78.5 82.5",
    style: {
      enableBackground: "new 0 0 78.5 82.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.opponent0{fill:#521159;}\n\t.opponent1{fill:#FFC5C0;}\n\t.opponent2{fill:#330434;}\n\t.opponent3{fill:#F37E72;}\n\t.opponent4{fill:#FAE9E7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "COMPUTER",
    transform: "translate(-1191 -20.026)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    className: "opponent0",
    cx: 1233.1,
    cy: 66.6,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_397",
    transform: "translate(1339.151 39.517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1158",
    className: "opponent1",
    d: "M-101,0.6l5.9,3.3l2.3,6.1l-0.9,7.9l2,0.3l1.4,2.9l-1.7,4.3l-2.5,1.1l-1.9-1.1l-1.9,6l-9,4 l-5.3,0.3l-5.8-1.7l-3.3-6.8l0.6-3.9l-0.8-8l0.4-3.9l0.4-4.4l0.9-3l9.2-3.7H-101z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_270",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_269"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1159",
    className: "opponent2",
    d: "M-94.6,23.8c0,0-1.1-0.3-1.1-2c0-1.7,2.3-3.2,2.8-2.6s-1.7,1.3-1.6,2.3 S-93.4,24.1-94.6,23.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1160",
    className: "opponent1",
    d: "M-98,29.7l-3.4,4.7l-12.7,3.4l-0.8,3.3l5,1.9l7.6-1.9l4.4-2.4v-6.1L-98,29.7z"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1571",
    className: "opponent3",
    d: "M1220.2,61.2l0.6,4l1-1.8l2.1,1.4l5.7,0l2.2-0.9l1.5,1.3l0.9-3.8l0.8,2.7l-0.6,2.3l-0.7-0.9 l-0.6,1.7l-0.5,1.5l-1-2l-0.7,2.3l-0.8,1.2l-0.6-1.5l-0.5-0.7l-1.4,2.2l-1.1-1.2l-0.5-1l-0.7,1l-0.3,1.2l-0.6-1.5l0-2l-1.9,2 l-0.3-1.5l0-0.9l-1.2,1.6l-1.4-2.3l-0.3-2.7L1220.2,61.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1573",
    className: "opponent3",
    d: "M1229.7,58.2l4.1-4.2h3.4l-1.9,4.2l-2.8,1.9l-3.7-0.7L1229.7,58.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1575",
    className: "opponent3",
    d: "M1222.2,58.3l-2.6-3.2h-2.1l1.2,3.2l1.8,1.5l2.3-0.6L1222.2,58.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_409",
    transform: "translate(1313.504 20.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1632",
    className: "opponent4",
    d: "M-119.5,22l4.2,4.2l-0.1,0.2l-5.8-1.2l-0.7,1.3l8.4,1.5l0.6-1.2l-5.9-6.2L-119.5,22z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_408"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_407"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1633",
    className: "opponent4",
    d: "M-110.3,22.9c-0.6,0.8-2,2.2-4.2,0.5c-2.3-1.7-1.3-3.5-0.8-4.2c0.5-0.7,1.9-2.2,4.3-0.5 C-108.8,20.4-109.8,22.2-110.3,22.9 M-111.9,19.8c-1.5-1.1-2.2-0.3-2.5,0.1c-0.3,0.5-0.9,1.4,0.6,2.5s2.2,0.3,2.5-0.1 C-111,21.8-110.4,20.9-111.9,19.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1634",
    className: "opponent4",
    d: "M-112.7,16c0.6-0.6-0.3-1.5-0.3-1.5l0.5-0.5l0.9,0.9l0.8-0.8l0.7,0.7l-0.8,0.8l2.3,2.2 c0,0,0.6,0.6,1.3-0.2l0.9,0.8c-0.2,0.3-0.5,0.5-0.8,0.6c-0.9,0.4-1.9,0.2-2.6-0.5l-2.1-2l-0.4,0.4l-0.7-0.7L-112.7,16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1635",
    className: "opponent4",
    d: "M-104.4,11.6l-0.7,1.2l-0.3-0.4c-0.3-0.4-0.9-0.6-1.3-0.3c0,0-0.1,0.1-0.1,0.1 c-0.7,0.5-0.9,1.5-0.4,2.2c0.1,0.1,0.1,0.2,0.2,0.2l2.1,2.6l-1,0.8l-3.9-4.9l1.1-0.9l0.8,1.5l0.3-0.2c-0.5-0.7-0.4-1.8,0.3-2.4 c0.7-0.8,1.8-0.9,2.6-0.2c0.2,0.1,0.3,0.3,0.4,0.5L-104.4,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1636",
    className: "opponent4",
    d: "M-98.5,8.7l-3.6,2.7c0.4,0.8,1.4,1.1,2.1,0.7c0.1,0,0.1-0.1,0.2-0.1 c0.7-0.3,1-1.1,0.7-1.8l1.2-0.3c0.4,1.2-0.1,2.5-1.3,3.1c-1.5,0.8-3.4,0.2-4.2-1.3c-0.8-1.5-0.3-3.3,1.1-4.1 c1.1-0.8,2.7-0.5,3.5,0.6c0,0.1,0.1,0.1,0.1,0.2L-98.5,8.7z M-102.5,10.6l2.5-1.9c-0.1-0.2-0.7-0.8-1.9,0.1 C-101.9,8.8-103.2,9.6-102.5,10.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1637",
    className: "opponent4",
    d: "M-89,6.9c0.1,1.3-0.7,2.4-2,2.7c-1.5,0.5-3.2-0.3-3.7-1.8c0-0.1-0.1-0.2-0.1-0.3 c-0.6-1.5,0.2-3.2,1.6-3.7c0.1-0.1,0.3-0.1,0.4-0.1c1.2-0.5,2.5,0,3.1,1.2l-1,0.8c-0.2-0.7-1-1.1-1.7-0.8c0,0-0.1,0-0.1,0 c0,0-1.7,0.3-1.1,2.3s2.2,1.4,2.2,1.4c0.7-0.1,1.2-0.9,1.1-1.6L-89,6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1638",
    className: "opponent4",
    d: "M-86.9,8.7l-1.3,0.2l-1-8.1l1.4-0.2l0.1,3.6l0.3,0c-0.1-1,0.6-1.8,1.6-2 c2.5-0.5,2.7,2.3,2.7,2.3l0.4,3.6L-84,8.3l-0.4-3.1c0,0-0.1-1.9-1.5-1.7c-0.9,0.1-1.6,1-1.5,1.9c0,0,0,0,0,0.1L-86.9,8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1639",
    className: "opponent4",
    d: "M-77.8,6.6l-0.3,0c-0.2,0.9-1,1.6-1.9,1.7c-2.5,0.1-2.4-1.6-2.4-1.6c0.1-1.6,2.5-2,2.5-2 l1.9-0.4c0-0.4-0.3-1.1-1.3-1.2c-1.6-0.1-1.8,0.8-1.8,0.8l-1.1-0.5c0,0,0.5-1.5,2.9-1.4c3,0.2,2.6,2.4,2.6,2.4l-0.1,2.2 c0,0-0.1,0.6,0.8,0.6l-0.1,1.2c-0.9,0.1-1.7-0.6-1.7-1.5C-77.8,6.8-77.8,6.7-77.8,6.6 M-78,5.2l-1.7,0.4c-1.4,0.3-1.3,1-1.3,1 c0,0.7,1.2,0.5,1.2,0.5C-78.8,6.9-78.1,6.1-78,5.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1640",
    className: "opponent4",
    d: "M-75.6,6.3l1-5.7l1.3,0.2l-1,6c-0.1,0.4,0.1,0.8,0.6,0.9c0,0,0.1,0,0.1,0L-73.9,9 c-0.3,0-0.5-0.1-0.7-0.2C-75.5,8.2-75.9,7.2-75.6,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1641",
    className: "opponent4",
    d: "M-73.1,6.7l1.4-5.6l1.3,0.3l-1.4,5.9c-0.1,0.4,0.1,0.8,0.5,1c0,0,0.1,0,0.1,0l-0.3,1.2 c-0.2,0-0.5-0.1-0.7-0.3C-73,8.7-73.4,7.7-73.1,6.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1642",
    className: "opponent4",
    d: "M-65,8.1l-4.4-0.9c-0.3,0.8,0,1.8,0.8,2.1c0.1,0,0.1,0,0.2,0.1c0.7,0.3,1.5,0,1.8-0.7 l1,0.8c-0.6,1.1-2,1.6-3.2,1c-1.6-0.6-2.4-2.4-1.8-4c0.6-1.6,2.3-2.4,3.9-1.8c1.3,0.4,2.1,1.7,1.8,3.1c0,0.1,0,0.1-0.1,0.2 L-65,8.1z M-69.1,6.3l3.1,0.7c0.1-0.2,0.1-1-1.3-1.4C-67.2,5.6-68.7,5.2-69.1,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1643",
    className: "opponent4",
    d: "M-64.7,12.1l-1.2-0.6l3-5.5l1.2,0.7L-62.7,8l0.3,0.2c0.5-0.8,1.5-1,2.3-0.6 c2.3,1.1,0.9,3.5,0.9,3.5l-1.7,3.2l-1.2-0.6l1.5-2.8c0,0,1.1-1.6-0.2-2.2c-0.8-0.4-1.8-0.2-2.2,0.6c0,0,0,0.1-0.1,0.1 L-64.7,12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1644",
    className: "opponent4",
    d: "M-53.6,12l1.1,0.9l-3.9,4.9c-0.7,1.1-2.2,1.5-3.4,0.8c-0.1-0.1-0.2-0.2-0.3-0.3 c-1-0.7-1.4-2.1-0.8-3.2l1.2,0.4c-0.4,0.6-0.3,1.4,0.4,1.9c0,0,0,0,0,0c0.6,0.5,1.5,0.3,2-0.3c0,0,0,0,0-0.1l1.1-1.4l-0.3-0.2 c-0.5,0.8-1.6,1-2.3,0.5c-0.1,0-0.1-0.1-0.2-0.1c-1.4-1.1-1-2.6,0-3.9c0,0,1.9-2.5,3.8-1.1c0.8,0.6,1,1.7,0.4,2.5l0.2,0.2 L-53.6,12z M-57.9,15c0,0,1.2,1.1,2.4-0.5c0.6-0.6,0.7-1.6,0.1-2.3c-0.1-0.1-0.1-0.1-0.2-0.2c-0.8-0.6-1.6-0.1-2.1,0.7 C-58.3,13.4-58.7,14.3-57.9,15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1645",
    className: "opponent4",
    d: "M-49.7,19.9l-3.4-2.9c-0.7,0.6-0.8,1.6-0.2,2.2c0,0,0.1,0.1,0.1,0.1 c0.5,0.6,1.3,0.7,1.9,0.3l0.5,1.1c-1.1,0.7-2.5,0.4-3.3-0.6c-1.1-1.3-1-3.3,0.3-4.4c1.3-1.1,3.1-1,4.3,0.2 c1,0.9,1.1,2.5,0.1,3.5c0,0.1-0.1,0.1-0.1,0.1L-49.7,19.9z M-52.4,16.5l2.4,2.1c0.2-0.1,0.6-0.9-0.5-1.9 C-50.5,16.7-51.6,15.6-52.4,16.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1646",
    className: "opponent4",
    d: "M-45.8,24.8l-1.1-0.9l0.5-0.3c0.5-0.2,0.7-0.8,0.4-1.3c0,0,0-0.1-0.1-0.1 c-0.4-0.8-1.4-1.1-2.2-0.6c-0.1,0-0.2,0.1-0.3,0.2l-2.8,1.8l-0.7-1.1l5.2-3.4l0.8,1.2l-1.6,0.6l0.2,0.3 c0.8-0.4,1.8-0.2,2.3,0.5c0.7,0.7,0.7,1.9,0,2.6c-0.1,0.1-0.3,0.3-0.5,0.3L-45.8,24.8z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayer2);
export default __webpack_public_path__ + "static/media/player-2.271f18c2d168fa8404de26ede4352475.svg";
export { ForwardRef as ReactComponent };